export const environment = {
  production: true,
  apiHostname: 'https://api.maviepro.net',
  apiUrl: 'https://api.maviepro.net/v2',
  assetUrl: 'https://api.maviepro.net/storage',
  socketUrl: 'https://api.socket.maviepro.net',
  application: 'maviepro'
};
